<template>
<!-- :xs="8" :sm="6" :md="4" :lg="3"  -->
    <span style="margin-top: 20px;">
        <el-row :gutter="20" class="hidden-md-and-up">
            <Carousel   
                    :per-page="1" 
                    :mouse-drag="true"
                    :autoplay="true"
                    :loop="true"
                    :paginationEnabled="false">
                <Slide>
                    <img class="chevere-carousel-img" src="@/../public/assets/images/tecnologias/apache.png" alt="Apache" title="Apache">
                </Slide>
                <Slide>
                    <img class="chevere-carousel-img" src="@/../public/assets/images/tecnologias/microsoft-iis_1.png" alt="Microsoft IIS" title="Microsoft IIS">
                </Slide>
                <Slide>
                    <img class="chevere-carousel-img" src="@/../public/assets/images/tecnologias/c-plus-plus.png" alt="C plus plus" title="C plus plus">
                </Slide>
                <Slide>
                    <img class="chevere-carousel-img" src="@/../public/assets/images/tecnologias/php.png" alt="PHP" title="PHP">
                </Slide>
                <Slide>
                    <img class="chevere-carousel-img" src="@/../public/assets/images/tecnologias/java.png" alt="java" title="java">
                </Slide>
                <Slide>
                    <img class="chevere-carousel-img" src="@/../public/assets/images/tecnologias/CSharp.png" alt="CSharp" title="CSharp">
                </Slide>
                <Slide>
                    <img class="chevere-carousel-img" src="@/../public/assets/images/tecnologias/Bootstrap.png" alt="Bootstrap" title="Bootstrap">
                </Slide>
                <Slide>
                    <img class="chevere-carousel-img" src="@/../public/assets/images/tecnologias/materialize.png" alt="Materialize" title="Materialize">
                </Slide>
                <Slide>
                    <img class="chevere-carousel-img" src="@/../public/assets/images/tecnologias/vuetify.png" alt="Vuetify" title="Vuetify">
                </Slide>
                <Slide>
                    <img class="chevere-carousel-img" src="@/../public/assets/images/tecnologias/CI.jpg" alt="CodeIgniter" title="CodeIgniter">
                </Slide>
                <Slide>
                    <img class="chevere-carousel-img" src="@/../public/assets/images/tecnologias/laravel.png" alt="Laravel" title="Laravel">
                </Slide>
                <Slide>
                    <img class="chevere-carousel-img" src="@/../public/assets/images/tecnologias/jquery.png" alt="JQuery" title="JQuery">
                </Slide>
                <Slide>
                    <img class="chevere-carousel-img" src="@/../public/assets/images/tecnologias/vue-logo.png" alt="Vue Js" title="Vue Js">
                </Slide>
                <Slide>
                    <img class="chevere-carousel-img" src="@/../public/assets/images/tecnologias/css3.png" alt="Css3" title="Css3">
                </Slide>
                <Slide>
                    <img class="chevere-carousel-img" src="@/../public/assets/images/tecnologias/HTML5.png" alt="HTML5" title="HTML5">
                </Slide>
                <Slide>
                    <img class="chevere-carousel-img" src="@/../public/assets/images/tecnologias/postgres.png" alt="PostgreSQL" title="PostgreSQL">
                </Slide>
                <Slide>
                    <img class="chevere-carousel-img" src="@/../public/assets/images/tecnologias/oracle.jpg" alt="Oracle" title="Oracle">
                </Slide>
                <Slide>
                    <img class="chevere-carousel-img" src="@/../public/assets/images/tecnologias/mysql.png" alt="MySql" title="MySql">
                </Slide>
                <Slide>
                    <img class="chevere-carousel-img" src="@/../public/assets/images/tecnologias/sql-server.png" alt="Sql Server" title="Sql Server">
                </Slide>
                <Slide>
                    <img class="chevere-carousel-img" src="@/../public/assets/images/tecnologias/Wserver.png" alt="Windows Server" title="Windows Server">
                </Slide>
                <Slide>
                    <img class="chevere-carousel-img" src="@/../public/assets/images/tecnologias/exchange.png" alt="Exchange" title="Exchange">
                </Slide>
            </Carousel>
        </el-row>
        <el-row style="marging-top: 15;" :gutter="20" class="hidden-sm-and-down">
            <Carousel   
                    :per-page="3" 
                    :mouse-drag="true"
                    :autoplay="true"
                    :loop="true">
                <Slide>
                    <img class="chevere-carousel-img" src="@/../public/assets/images/tecnologias/apache.png" alt="Apache" title="Apache">
                </Slide>
                <Slide>
                    <img class="chevere-carousel-img" src="@/../public/assets/images/tecnologias/microsoft-iis_1.png" alt="Microsoft IIS" title="Microsoft IIS">
                </Slide>
                <Slide>
                    <img class="chevere-carousel-img" src="@/../public/assets/images/tecnologias/c-plus-plus.png" alt="C plus plus" title="C plus plus">
                </Slide>
                <Slide>
                    <img class="chevere-carousel-img" src="@/../public/assets/images/tecnologias/php.png" alt="PHP" title="PHP">
                </Slide>
                <Slide>
                    <img class="chevere-carousel-img" src="@/../public/assets/images/tecnologias/java.png" alt="java" title="java">
                </Slide>
                <Slide>
                    <img class="chevere-carousel-img" src="@/../public/assets/images/tecnologias/CSharp.png" alt="CSharp" title="CSharp">
                </Slide>
                <Slide>
                    <img class="chevere-carousel-img" src="@/../public/assets/images/tecnologias/Bootstrap.png" alt="Bootstrap" title="Bootstrap">
                </Slide>
                <Slide>
                    <img class="chevere-carousel-img" src="@/../public/assets/images/tecnologias/materialize.png" alt="Materialize" title="Materialize">
                </Slide>
                <Slide>
                    <img class="chevere-carousel-img" src="@/../public/assets/images/tecnologias/vuetify.png" alt="Vuetify" title="Vuetify">
                </Slide>
                <Slide>
                    <img class="chevere-carousel-img" src="@/../public/assets/images/tecnologias/CI.jpg" alt="CodeIgniter" title="CodeIgniter">
                </Slide>
                <Slide>
                    <img class="chevere-carousel-img" src="@/../public/assets/images/tecnologias/laravel.png" alt="Laravel" title="Laravel">
                </Slide>
                <Slide>
                    <img class="chevere-carousel-img" src="@/../public/assets/images/tecnologias/jquery.png" alt="JQuery" title="JQuery">
                </Slide>
                <Slide>
                    <img class="chevere-carousel-img" src="@/../public/assets/images/tecnologias/vue-logo.png" alt="Vue Js" title="Vue Js">
                </Slide>
                <Slide>
                    <img class="chevere-carousel-img" src="@/../public/assets/images/tecnologias/css3.png" alt="Css3" title="Css3">
                </Slide>
                <Slide>
                    <img class="chevere-carousel-img" src="@/../public/assets/images/tecnologias/HTML5.png" alt="HTML5" title="HTML5">
                </Slide>
                <Slide>
                    <img class="chevere-carousel-img" src="@/../public/assets/images/tecnologias/postgres.png" alt="PostgreSQL" title="PostgreSQL">
                </Slide>
                <Slide>
                    <img class="chevere-carousel-img" src="@/../public/assets/images/tecnologias/oracle.jpg" alt="Oracle" title="Oracle">
                </Slide>
                <Slide>
                    <img class="chevere-carousel-img" src="@/../public/assets/images/tecnologias/mysql.png" alt="MySql" title="MySql">
                </Slide>
                <Slide>
                    <img class="chevere-carousel-img" src="@/../public/assets/images/tecnologias/sql-server.png" alt="Sql Server" title="Sql Server">
                </Slide>
                <Slide>
                    <img class="chevere-carousel-img" src="@/../public/assets/images/tecnologias/Wserver.png" alt="Windows Server" title="Windows Server">
                </Slide>
                <Slide>
                    <img class="chevere-carousel-img" src="@/../public/assets/images/tecnologias/exchange.png" alt="Exchange" title="Exchange">
                </Slide>
            </Carousel>
        </el-row>
    </span>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';

export default {
    name: "tecnologias",
    components: {
        Carousel,
        Slide
    }
}
</script>

<style scoped>

</style>





// WEBPACK FOOTER //
// src/sections/Tecnologias.vue